import { render, staticRenderFns } from "./PersonnelTable.vue?vue&type=template&id=617e6813&scoped=true"
import script from "./PersonnelTable.vue?vue&type=script&lang=js"
export * from "./PersonnelTable.vue?vue&type=script&lang=js"
import style0 from "./PersonnelTable.vue?vue&type=style&index=0&id=617e6813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e6813",
  null
  
)

export default component.exports